var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.getLoading,"opacity":"1","z-index":"99999999","color":_vm.getDarker ? 'black':'white'}},[_c('v-img',{attrs:{"src":_vm.loadingImage,"width":"100"}}),_c('div',{staticClass:"ma-2"},[_vm._v(" loading ...... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }